import { render, staticRenderFns } from "./TestTypeNew.vue?vue&type=template&id=763c76c6&"
import script from "./TestTypeNew.vue?vue&type=script&lang=js&"
export * from "./TestTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports